module.exports = __webpack_public_path__ + "img/banner_generic_left.d5a8cdee.jpg";